import styled from "styled-components";

export const StyledNav = styled.nav`
  height: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;

  ul {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  li {
    color: var(--dark--secondary--text);
    margin: 0 1.5rem;
    cursor: pointer;
    border-bottom: 2px solid var(--dark--background);
  }

  li:hover {
    border-bottom: 2px solid var(--dark--green--50);
  }
`;

export const Button = styled.button`
  border: none;
  text-decoration: none;
`;
